import React from "react";
import { useTranslation } from "react-i18next";

const logo = "/img/logo.png";

const Hero = () => {
  const { t } = useTranslation();

  return (
    <div className="text-center hero">
      <img className="mb-3 app-logo" src={logo} alt="React logo" width="200" />
      <h1 className="mb-4">{t("hero.heading")}</h1>
      <p className="lead mb-5">{t("hero.description")}</p>
    </div>
  );
};

export default Hero;
